import { ServiceWithRFQID } from '@/services/Service'
import { ModelRFQ3 } from './models'
const ENDPOINTS = {
  GET: 'RFQ3s/Get',
  GET_DYNAMIC: 'RFQ3s/GetAllDynamic',
  POST: 'RFQ3s/Create',
  PATCH: 'RFQ3s/Patch',
  PUT: 'RFQ3s/Put',
  DELETE: 'RFQ3s/Delete'
}

class ModuleServiceRFQ3s extends ServiceWithRFQID {
  getModel () {
    return {
      id: null,
      rfqid: null,
      chosen: false,
      qty: 1,
      partID: null,
      partSN: '',
      price: '',
      currencyID: null,
      conditionID: null,
      releaseID: null,
      traceabilityCompanyID: null,
      tagInfoCompanyID: null,
      tagDate: null,
      supplyDate: '',
      stockID: null,
      exchangeCoreValue: null,
      exchangeCoreValueCurrencyID: null,
      exchangeConditionID: null,
      coreDueDate: null,
      exchangeCoreReceived: false,
      sendMail: false,
      remarks: ''
    }
  }
}
export const ServiceRFQ3s = new ModuleServiceRFQ3s({
  apiGet: ENDPOINTS.GET,
  apiGetDynamic: ENDPOINTS.GET_DYNAMIC,
  apiPost: ENDPOINTS.POST,
  apiPatch: ENDPOINTS.PATCH,
  apiPut: ENDPOINTS.PUT,
  apiDelete: ENDPOINTS.DELETE
})

export {
  ModelRFQ3
}
